// **********************************************************************
// This file was generated by a TAF parser!
// TAF version 2.1.7.7
// Generated from `FriendFissionServant.jce'
// **********************************************************************
import { Taf } from '@huyafed/taf-network';
var HUYA = HUYA || {};

HUYA.ELiveSource = {
  PC_YY: 0,
  PC_HUYA: 1,
  MOBILE_HUYA: 2,
  WEB_HUYA: 3
};

HUYA.TemplateType = {
  PRIMARY: 1,
  RECEPTION: 2
};

HUYA.eUserOperation = {
  USER_IN: 1,
  USER_OUT: 2,
  USER_MOVE: 3
};

HUYA.UserId = function () {
  this.lUid = 0;
  this.sGuid = '';
  this.sToken = '';
  this.sHuYaUA = '';
  this.sCookie = '';
  this.iTokenType = 0;
  this.sDeviceInfo = '';
};
HUYA.UserId.prototype._clone = function () {
  return new HUYA.UserId();
};
HUYA.UserId.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.UserId.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.UserId.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeString(1, this.sGuid);
  os.writeString(2, this.sToken);
  os.writeString(3, this.sHuYaUA);
  os.writeString(4, this.sCookie);
  os.writeInt32(5, this.iTokenType);
  os.writeString(6, this.sDeviceInfo);
};

HUYA.UserId.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.sGuid = is.readString(1, false, this.sGuid);
  this.sToken = is.readString(2, false, this.sToken);
  this.sHuYaUA = is.readString(3, false, this.sHuYaUA);
  this.sCookie = is.readString(4, false, this.sCookie);
  this.iTokenType = is.readInt32(5, false, this.iTokenType);
  this.sDeviceInfo = is.readString(6, false, this.sDeviceInfo);
};

HUYA.UserEventRsp = function () {
  this.lTid = 0;
  this.lSid = 0;
  this.iUserHeartBeatInterval = 60;
  this.iPresentHeartBeatInterval = 60;
};
HUYA.UserEventRsp.prototype._clone = function () {
  return new HUYA.UserEventRsp();
};
HUYA.UserEventRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.UserEventRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.UserEventRsp.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lTid);
  os.writeInt64(1, this.lSid);
  os.writeInt32(2, this.iUserHeartBeatInterval);
  os.writeInt32(3, this.iPresentHeartBeatInterval);
};

HUYA.UserEventRsp.prototype.readFrom = function (is) {
  this.lTid = is.readInt64(0, false, this.lTid);
  this.lSid = is.readInt64(1, false, this.lSid);
  this.iUserHeartBeatInterval = is.readInt32(
    2,
    false,
    this.iUserHeartBeatInterval
  );
  this.iPresentHeartBeatInterval = is.readInt32(
    3,
    false,
    this.iPresentHeartBeatInterval
  );
};

HUYA.UserEventReq = function () {
  this.tId = new HUYA.UserId();
  this.lTid = 0;
  this.lSid = 0;
  this.eOp = 0;
  this.sChan = '';
  this.eSource = 0;
  this.lPid = 0;
  this.bWatchVideo = false;
  this.bAnonymous = false;
  this.eTemplateType = HUYA.TemplateType.PRIMARY;
  this.sTraceSource = '';
};
HUYA.UserEventReq.prototype._clone = function () {
  return new HUYA.UserEventReq();
};
HUYA.UserEventReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.UserEventReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.UserEventReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt64(1, this.lTid);
  os.writeInt64(2, this.lSid);
  os.writeInt32(4, this.eOp);
  os.writeString(5, this.sChan);
  os.writeInt32(6, this.eSource);
  os.writeInt64(7, this.lPid);
  os.writeBoolean(8, this.bWatchVideo);
  os.writeBoolean(9, this.bAnonymous);
  os.writeInt32(10, this.eTemplateType);
  os.writeString(11, this.sTraceSource);
};

HUYA.UserEventReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.lTid = is.readInt64(1, false, this.lTid);
  this.lSid = is.readInt64(2, false, this.lSid);
  this.eOp = is.readInt32(4, false, this.eOp);
  this.sChan = is.readString(5, false, this.sChan);
  this.eSource = is.readInt32(6, false, this.eSource);
  this.lPid = is.readInt64(7, false, this.lPid);
  this.bWatchVideo = is.readBoolean(8, false, this.bWatchVideo);
  this.bAnonymous = is.readBoolean(9, false, this.bAnonymous);
  this.eTemplateType = is.readInt32(10, false, this.eTemplateType);
  this.sTraceSource = is.readString(11, false, this.sTraceSource);
};

HUYA.FissionInvedType = {
  Fission_InvedType_No: 0,
  Fission_InvedType_Back: 1,
  Fission_InvedType_New: 2,
  Fission_InvedType_Comm: 3
};

HUYA.FissionShareType = {
  Fission_Share_None: 0,
  Fission_Share_QQ: 1,
  Fission_Share_WeiXin: 2,
  Fission_Share_Link: 3,
  Fission_Share_FaceFace: 4,
  Fission_Share_WeiBo: 5
};

HUYA.FissionShareStyle = {
  Fission_Style_Inv: 1,
  Fission_Style_Letter: 2,
  Fission_Style_Panel: 4,
  Fission_Style_Bubble: 8,
  Fission_Style_LinkPanel: 16
};

HUYA.FissionGift = function () {
  this.iItemType = 0;
  this.iItemCount = 0;
};
HUYA.FissionGift.prototype._clone = function () {
  return new HUYA.FissionGift();
};
HUYA.FissionGift.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionGift.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionGift.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iItemType);
  os.writeInt32(1, this.iItemCount);
};

HUYA.FissionGift.prototype.readFrom = function (is) {
  this.iItemType = is.readInt32(0, false, this.iItemType);
  this.iItemCount = is.readInt32(1, false, this.iItemCount);
};

HUYA.AcceptMsg = function () {
  this.sTitle = '';
  this.sSubTitle = '';
  this.sContent = '';
  this.sBottonTitle = '';
  this.sJumpUrl = '';
};
HUYA.AcceptMsg.prototype._clone = function () {
  return new HUYA.AcceptMsg();
};
HUYA.AcceptMsg.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.AcceptMsg.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.AcceptMsg.prototype.writeTo = function (os) {
  os.writeString(0, this.sTitle);
  os.writeString(1, this.sSubTitle);
  os.writeString(2, this.sContent);
  os.writeString(3, this.sBottonTitle);
  os.writeString(4, this.sJumpUrl);
};

HUYA.AcceptMsg.prototype.readFrom = function (is) {
  this.sTitle = is.readString(0, false, this.sTitle);
  this.sSubTitle = is.readString(1, false, this.sSubTitle);
  this.sContent = is.readString(2, false, this.sContent);
  this.sBottonTitle = is.readString(3, false, this.sBottonTitle);
  this.sJumpUrl = is.readString(4, false, this.sJumpUrl);
};

HUYA.FissionAwardConfigItem = function () {
  this.lPrice = 0;
  this.lFirstCash = 0;
  this.lSecondCash = 0;
  this.lSevenCash = 0;
  this.vGift = new Taf.Vector(new HUYA.FissionGift());
  this.lExp = 0;
  this.lPoint = 0;
  this.mDayCash = new Taf.Map(new Taf.INT32(), new Taf.INT64());
};
HUYA.FissionAwardConfigItem.prototype._clone = function () {
  return new HUYA.FissionAwardConfigItem();
};
HUYA.FissionAwardConfigItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionAwardConfigItem.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionAwardConfigItem.prototype.writeTo = function (os) {
  os.writeInt64(2, this.lPrice);
  os.writeInt64(3, this.lFirstCash);
  os.writeInt64(4, this.lSecondCash);
  os.writeInt64(5, this.lSevenCash);
  os.writeVector(6, this.vGift);
  os.writeInt64(7, this.lExp);
  os.writeInt64(8, this.lPoint);
  os.writeMap(9, this.mDayCash);
};

HUYA.FissionAwardConfigItem.prototype.readFrom = function (is) {
  this.lPrice = is.readInt64(2, false, this.lPrice);
  this.lFirstCash = is.readInt64(3, false, this.lFirstCash);
  this.lSecondCash = is.readInt64(4, false, this.lSecondCash);
  this.lSevenCash = is.readInt64(5, false, this.lSevenCash);
  this.vGift = is.readVector(6, false, this.vGift);
  this.lExp = is.readInt64(7, false, this.lExp);
  this.lPoint = is.readInt64(8, false, this.lPoint);
  this.mDayCash = is.readMap(9, false, this.mDayCash);
};

HUYA.FissionAwardConfig = function () {
  this.tInvedItem = new HUYA.FissionAwardConfigItem();
  this.tNewItem = new HUYA.FissionAwardConfigItem();
  this.tBackItem = new HUYA.FissionAwardConfigItem();
  this.tCommItem = new HUYA.FissionAwardConfigItem();
};
HUYA.FissionAwardConfig.prototype._clone = function () {
  return new HUYA.FissionAwardConfig();
};
HUYA.FissionAwardConfig.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionAwardConfig.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionAwardConfig.prototype.writeTo = function (os) {
  os.writeStruct(1, this.tInvedItem);
  os.writeStruct(2, this.tNewItem);
  os.writeStruct(3, this.tBackItem);
  os.writeStruct(4, this.tCommItem);
};

HUYA.FissionAwardConfig.prototype.readFrom = function (is) {
  this.tInvedItem = is.readStruct(1, false, this.tInvedItem);
  this.tNewItem = is.readStruct(2, false, this.tNewItem);
  this.tBackItem = is.readStruct(3, false, this.tBackItem);
  this.tCommItem = is.readStruct(4, false, this.tCommItem);
};

HUYA.UdbNodeInfo = function () {
  this.tId = new HUYA.UserId();
  this.lInvUid = 0;
  this.sDid = '';
  this.mContext = new Taf.Map(new Taf.STRING(), new Taf.STRING());
  this.sMid = '';
};
HUYA.UdbNodeInfo.prototype._clone = function () {
  return new HUYA.UdbNodeInfo();
};
HUYA.UdbNodeInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.UdbNodeInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.UdbNodeInfo.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt64(1, this.lInvUid);
  os.writeString(2, this.sDid);
  os.writeMap(3, this.mContext);
  os.writeString(4, this.sMid);
};

HUYA.UdbNodeInfo.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.lInvUid = is.readInt64(1, false, this.lInvUid);
  this.sDid = is.readString(2, false, this.sDid);
  this.mContext = is.readMap(3, false, this.mContext);
  this.sMid = is.readString(4, false, this.sMid);
};

HUYA.FissionInvitationAward = function () {
  this.lExp = 0;
  this.lPoint = 0;
  this.lCash = 0;
  this.lValue = 0;
  this.lAwardTime = 0;
  this.sReason = '';
  this.vGift = new Taf.Vector(new HUYA.FissionGift());
  this.sOrderId = '';
  this.iStatus = 0;
  this.iInvedType = 0;
  this.iTaskStu = 0;
};
HUYA.FissionInvitationAward.prototype._clone = function () {
  return new HUYA.FissionInvitationAward();
};
HUYA.FissionInvitationAward.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionInvitationAward.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionInvitationAward.prototype.writeTo = function (os) {
  os.writeInt64(1, this.lExp);
  os.writeInt64(2, this.lPoint);
  os.writeInt64(3, this.lCash);
  os.writeInt64(4, this.lValue);
  os.writeInt64(5, this.lAwardTime);
  os.writeString(6, this.sReason);
  os.writeVector(7, this.vGift);
  os.writeString(8, this.sOrderId);
  os.writeInt32(9, this.iStatus);
  os.writeInt32(10, this.iInvedType);
  os.writeInt32(11, this.iTaskStu);
};

HUYA.FissionInvitationAward.prototype.readFrom = function (is) {
  this.lExp = is.readInt64(1, false, this.lExp);
  this.lPoint = is.readInt64(2, false, this.lPoint);
  this.lCash = is.readInt64(3, false, this.lCash);
  this.lValue = is.readInt64(4, false, this.lValue);
  this.lAwardTime = is.readInt64(5, false, this.lAwardTime);
  this.sReason = is.readString(6, false, this.sReason);
  this.vGift = is.readVector(7, false, this.vGift);
  this.sOrderId = is.readString(8, false, this.sOrderId);
  this.iStatus = is.readInt32(9, false, this.iStatus);
  this.iInvedType = is.readInt32(10, false, this.iInvedType);
  this.iTaskStu = is.readInt32(11, false, this.iTaskStu);
};

HUYA.FissionInvAwardInfo = function () {
  this.mAward = new Taf.Map(new Taf.INT32(), new HUYA.FissionInvitationAward());
  this.lValue = 0;
  this.lCash = 0;
};
HUYA.FissionInvAwardInfo.prototype._clone = function () {
  return new HUYA.FissionInvAwardInfo();
};
HUYA.FissionInvAwardInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionInvAwardInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionInvAwardInfo.prototype.writeTo = function (os) {
  os.writeMap(0, this.mAward);
  os.writeInt64(1, this.lValue);
  os.writeInt64(2, this.lCash);
};

HUYA.FissionInvAwardInfo.prototype.readFrom = function (is) {
  this.mAward = is.readMap(0, false, this.mAward);
  this.lValue = is.readInt64(1, false, this.lValue);
  this.lCash = is.readInt64(2, false, this.lCash);
};

HUYA.FissionInvedUserStatus = function () {
  this.tAward = new HUYA.FissionInvAwardInfo();
  this.iStatus = 0;
  this.lInvedUid = 0;
  this.iInvedType = 0;
  this.sAvatarUrl = '';
  this.sNickName = '';
  this.lInvUid = 0;
  this.lInvedTime = 0;
  this.sLoginDay = '';
  this.lPid = 0;
  this.sChannelId = '';
  this.iChannelType = 0;
  this.sHuyaDeviceid = '';
  this.iSceneType1 = 0;
  this.iSceneType2 = 0;
};
HUYA.FissionInvedUserStatus.prototype._clone = function () {
  return new HUYA.FissionInvedUserStatus();
};
HUYA.FissionInvedUserStatus.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionInvedUserStatus.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionInvedUserStatus.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tAward);
  os.writeInt32(1, this.iStatus);
  os.writeInt64(2, this.lInvedUid);
  os.writeInt32(3, this.iInvedType);
  os.writeString(4, this.sAvatarUrl);
  os.writeString(5, this.sNickName);
  os.writeInt64(6, this.lInvUid);
  os.writeInt64(7, this.lInvedTime);
  os.writeString(8, this.sLoginDay);
  os.writeInt64(9, this.lPid);
  os.writeString(10, this.sChannelId);
  os.writeInt32(11, this.iChannelType);
  os.writeString(12, this.sHuyaDeviceid);
  os.writeInt32(13, this.iSceneType1);
  os.writeInt32(14, this.iSceneType2);
};

HUYA.FissionInvedUserStatus.prototype.readFrom = function (is) {
  this.tAward = is.readStruct(0, false, this.tAward);
  this.iStatus = is.readInt32(1, false, this.iStatus);
  this.lInvedUid = is.readInt64(2, false, this.lInvedUid);
  this.iInvedType = is.readInt32(3, false, this.iInvedType);
  this.sAvatarUrl = is.readString(4, false, this.sAvatarUrl);
  this.sNickName = is.readString(5, false, this.sNickName);
  this.lInvUid = is.readInt64(6, false, this.lInvUid);
  this.lInvedTime = is.readInt64(7, false, this.lInvedTime);
  this.sLoginDay = is.readString(8, false, this.sLoginDay);
  this.lPid = is.readInt64(9, false, this.lPid);
  this.sChannelId = is.readString(10, false, this.sChannelId);
  this.iChannelType = is.readInt32(11, false, this.iChannelType);
  this.sHuyaDeviceid = is.readString(12, false, this.sHuyaDeviceid);
  this.iSceneType1 = is.readInt32(13, false, this.iSceneType1);
  this.iSceneType2 = is.readInt32(14, false, this.iSceneType2);
};

HUYA.FissionInvitationInfoReq = function () {
  this.tId = new HUYA.UserId();
  this.iStart = 0;
  this.iCount = 0;
  this.lPid = 0;
  this.lRoomId = 0;
  this.sChannelId = '';
  this.iChannelType = 0;
  this.sMsg = '';
  this.iIsUpdateOpenPageTime = 0;
};
HUYA.FissionInvitationInfoReq.prototype._clone = function () {
  return new HUYA.FissionInvitationInfoReq();
};
HUYA.FissionInvitationInfoReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionInvitationInfoReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionInvitationInfoReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt32(1, this.iStart);
  os.writeInt32(2, this.iCount);
  os.writeInt64(3, this.lPid);
  os.writeInt64(4, this.lRoomId);
  os.writeString(5, this.sChannelId);
  os.writeInt32(6, this.iChannelType);
  os.writeString(7, this.sMsg);
  os.writeInt32(8, this.iIsUpdateOpenPageTime);
};

HUYA.FissionInvitationInfoReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.iStart = is.readInt32(1, false, this.iStart);
  this.iCount = is.readInt32(2, false, this.iCount);
  this.lPid = is.readInt64(3, false, this.lPid);
  this.lRoomId = is.readInt64(4, false, this.lRoomId);
  this.sChannelId = is.readString(5, false, this.sChannelId);
  this.iChannelType = is.readInt32(6, false, this.iChannelType);
  this.sMsg = is.readString(7, false, this.sMsg);
  this.iIsUpdateOpenPageTime = is.readInt32(
    8,
    false,
    this.iIsUpdateOpenPageTime
  );
};

HUYA.FissionInvitationInfoRsp = function () {
  this.iReturnCode = 0;
  this.iInvCount = 0;
  this.vInvedUserStatus = new Taf.Vector(new HUYA.FissionInvedUserStatus());
  this.mInved = new Taf.Map(new Taf.INT32(), new Taf.INT32());
  this.iInvedType = 0;
  this.tTotal = new HUYA.FissionInvitationAward();
  this.mInvCode = new Taf.Map(new Taf.INT32(), new Taf.STRING());
  this.lStartTime = 0;
  this.lEndTime = 0;
  this.iToast = 0;
  this.tDefaultAward = new HUYA.FissionAwardConfig();
  this.tInvedUserStatus = new HUYA.FissionInvedUserStatus();
  this.iV3Group = 0;
  this.sMsg = '';
  this.tCurrentTotal = new HUYA.FissionInvitationAward();
  this.iCurrentInvCount = 0;
};
HUYA.FissionInvitationInfoRsp.prototype._clone = function () {
  return new HUYA.FissionInvitationInfoRsp();
};
HUYA.FissionInvitationInfoRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionInvitationInfoRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionInvitationInfoRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iReturnCode);
  os.writeInt32(1, this.iInvCount);
  os.writeVector(2, this.vInvedUserStatus);
  os.writeMap(3, this.mInved);
  os.writeInt32(4, this.iInvedType);
  os.writeStruct(5, this.tTotal);
  os.writeMap(6, this.mInvCode);
  os.writeInt64(7, this.lStartTime);
  os.writeInt64(8, this.lEndTime);
  os.writeInt32(9, this.iToast);
  os.writeStruct(10, this.tDefaultAward);
  os.writeStruct(11, this.tInvedUserStatus);
  os.writeInt32(12, this.iV3Group);
  os.writeString(13, this.sMsg);
  os.writeStruct(14, this.tCurrentTotal);
  os.writeInt32(15, this.iCurrentInvCount);
};

HUYA.FissionInvitationInfoRsp.prototype.readFrom = function (is) {
  this.iReturnCode = is.readInt32(0, false, this.iReturnCode);
  this.iInvCount = is.readInt32(1, false, this.iInvCount);
  this.vInvedUserStatus = is.readVector(2, false, this.vInvedUserStatus);
  this.mInved = is.readMap(3, false, this.mInved);
  this.iInvedType = is.readInt32(4, false, this.iInvedType);
  this.tTotal = is.readStruct(5, false, this.tTotal);
  this.mInvCode = is.readMap(6, false, this.mInvCode);
  this.lStartTime = is.readInt64(7, false, this.lStartTime);
  this.lEndTime = is.readInt64(8, false, this.lEndTime);
  this.iToast = is.readInt32(9, false, this.iToast);
  this.tDefaultAward = is.readStruct(10, false, this.tDefaultAward);
  this.tInvedUserStatus = is.readStruct(11, false, this.tInvedUserStatus);
  this.iV3Group = is.readInt32(12, false, this.iV3Group);
  this.sMsg = is.readString(13, false, this.sMsg);
  this.tCurrentTotal = is.readStruct(14, false, this.tCurrentTotal);
  this.iCurrentInvCount = is.readInt32(15, false, this.iCurrentInvCount);
};

HUYA.StyleResource = function () {
  this.sIntroduce = '';
  this.sBackGroupImg = '';
  this.sButtonImg = '';
  this.sFrontImg = '';
  this.sJumpUrl = '';
};
HUYA.StyleResource.prototype._clone = function () {
  return new HUYA.StyleResource();
};
HUYA.StyleResource.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.StyleResource.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.StyleResource.prototype.writeTo = function (os) {
  os.writeString(0, this.sIntroduce);
  os.writeString(1, this.sBackGroupImg);
  os.writeString(2, this.sButtonImg);
  os.writeString(3, this.sFrontImg);
  os.writeString(4, this.sJumpUrl);
};

HUYA.StyleResource.prototype.readFrom = function (is) {
  this.sIntroduce = is.readString(0, false, this.sIntroduce);
  this.sBackGroupImg = is.readString(1, false, this.sBackGroupImg);
  this.sButtonImg = is.readString(2, false, this.sButtonImg);
  this.sFrontImg = is.readString(3, false, this.sFrontImg);
  this.sJumpUrl = is.readString(4, false, this.sJumpUrl);
};

HUYA.FissionInvitationSceneGroup = function () {
  this.iStyle = 0;
  this.mStyleResource = new Taf.Map(new Taf.INT32(), new HUYA.StyleResource());
  this.sGroupId = '';
};
HUYA.FissionInvitationSceneGroup.prototype._clone = function () {
  return new HUYA.FissionInvitationSceneGroup();
};
HUYA.FissionInvitationSceneGroup.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionInvitationSceneGroup.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionInvitationSceneGroup.prototype.writeTo = function (os) {
  os.writeInt32(1, this.iStyle);
  os.writeMap(3, this.mStyleResource);
  os.writeString(4, this.sGroupId);
};

HUYA.FissionInvitationSceneGroup.prototype.readFrom = function (is) {
  this.iStyle = is.readInt32(1, false, this.iStyle);
  this.mStyleResource = is.readMap(3, false, this.mStyleResource);
  this.sGroupId = is.readString(4, false, this.sGroupId);
};

HUYA.SceneshowConfig = function () {
  this.iShowTime = 0;
  this.iShowExpireTime = 0;
  this.iMonthTimes = 0;
};
HUYA.SceneshowConfig.prototype._clone = function () {
  return new HUYA.SceneshowConfig();
};
HUYA.SceneshowConfig.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.SceneshowConfig.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.SceneshowConfig.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iShowTime);
  os.writeInt32(1, this.iShowExpireTime);
  os.writeInt32(2, this.iMonthTimes);
};

HUYA.SceneshowConfig.prototype.readFrom = function (is) {
  this.iShowTime = is.readInt32(0, false, this.iShowTime);
  this.iShowExpireTime = is.readInt32(1, false, this.iShowExpireTime);
  this.iMonthTimes = is.readInt32(2, false, this.iMonthTimes);
};

HUYA.FissionInvitationSceneReq = function () {
  this.tId = new HUYA.UserId();
  this.lPid = 0;
  this.iGameId = 0;
  this.lRoomId = 0;
  this.iSceneType1 = 0;
  this.iSceneType2 = 0;
};
HUYA.FissionInvitationSceneReq.prototype._clone = function () {
  return new HUYA.FissionInvitationSceneReq();
};
HUYA.FissionInvitationSceneReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionInvitationSceneReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionInvitationSceneReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt64(1, this.lPid);
  os.writeInt32(2, this.iGameId);
  os.writeInt64(3, this.lRoomId);
  os.writeInt32(4, this.iSceneType1);
  os.writeInt32(5, this.iSceneType2);
};

HUYA.FissionInvitationSceneReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.lPid = is.readInt64(1, false, this.lPid);
  this.iGameId = is.readInt32(2, false, this.iGameId);
  this.lRoomId = is.readInt64(3, false, this.lRoomId);
  this.iSceneType1 = is.readInt32(4, false, this.iSceneType1);
  this.iSceneType2 = is.readInt32(5, false, this.iSceneType2);
};

HUYA.FissionInvitationSceneRsp = function () {
  this.iReturnCode = 0;
  this.mInvCode = new Taf.Map(new Taf.INT32(), new Taf.STRING());
  this.tGroup = new HUYA.FissionInvitationSceneGroup();
  this.lStartTime = 0;
  this.lEndTime = 0;
  this.tConfig = new HUYA.SceneshowConfig();
  this.sMsg = '';
};
HUYA.FissionInvitationSceneRsp.prototype._clone = function () {
  return new HUYA.FissionInvitationSceneRsp();
};
HUYA.FissionInvitationSceneRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionInvitationSceneRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionInvitationSceneRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iReturnCode);
  os.writeMap(1, this.mInvCode);
  os.writeStruct(2, this.tGroup);
  os.writeInt64(4, this.lStartTime);
  os.writeInt64(5, this.lEndTime);
  os.writeStruct(6, this.tConfig);
  os.writeString(7, this.sMsg);
};

HUYA.FissionInvitationSceneRsp.prototype.readFrom = function (is) {
  this.iReturnCode = is.readInt32(0, false, this.iReturnCode);
  this.mInvCode = is.readMap(1, false, this.mInvCode);
  this.tGroup = is.readStruct(2, false, this.tGroup);
  this.lStartTime = is.readInt64(4, false, this.lStartTime);
  this.lEndTime = is.readInt64(5, false, this.lEndTime);
  this.tConfig = is.readStruct(6, false, this.tConfig);
  this.sMsg = is.readString(7, false, this.sMsg);
};

HUYA.FissionInvCodeReq = function () {
  this.tId = new HUYA.UserId();
  this.lPid = 0;
  this.lRoomId = 0;
  this.iChannelType = 0;
  this.sMsg = '';
  this.iSceneType1 = 0;
  this.iSceneType2 = 0;
};
HUYA.FissionInvCodeReq.prototype._clone = function () {
  return new HUYA.FissionInvCodeReq();
};
HUYA.FissionInvCodeReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionInvCodeReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionInvCodeReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt64(1, this.lPid);
  os.writeInt64(2, this.lRoomId);
  os.writeInt32(3, this.iChannelType);
  os.writeString(4, this.sMsg);
  os.writeInt32(5, this.iSceneType1);
  os.writeInt32(6, this.iSceneType2);
};

HUYA.FissionInvCodeReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.lPid = is.readInt64(1, false, this.lPid);
  this.lRoomId = is.readInt64(2, false, this.lRoomId);
  this.iChannelType = is.readInt32(3, false, this.iChannelType);
  this.sMsg = is.readString(4, false, this.sMsg);
  this.iSceneType1 = is.readInt32(5, false, this.iSceneType1);
  this.iSceneType2 = is.readInt32(6, false, this.iSceneType2);
};

HUYA.FissionInvCodeRsp = function () {
  this.mInvCode = new Taf.Map(new Taf.INT32(), new Taf.STRING());
  this.sMsg = '';
};
HUYA.FissionInvCodeRsp.prototype._clone = function () {
  return new HUYA.FissionInvCodeRsp();
};
HUYA.FissionInvCodeRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionInvCodeRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionInvCodeRsp.prototype.writeTo = function (os) {
  os.writeMap(0, this.mInvCode);
  os.writeString(1, this.sMsg);
};

HUYA.FissionInvCodeRsp.prototype.readFrom = function (is) {
  this.mInvCode = is.readMap(0, false, this.mInvCode);
  this.sMsg = is.readString(1, false, this.sMsg);
};

HUYA.FissionInvitationDetail = function () {
  this.iStatus = 0;
  this.tAward = new HUYA.FissionInvitationAward();
  this.lInvedUid = 0;
  this.iInvedType = 0;
  this.sAvatarUrl = '';
  this.sNickName = '';
  this.lInvUid = 0;
  this.lInvedTime = 0;
  this.sOrderId = '';
};
HUYA.FissionInvitationDetail.prototype._clone = function () {
  return new HUYA.FissionInvitationDetail();
};
HUYA.FissionInvitationDetail.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionInvitationDetail.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionInvitationDetail.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iStatus);
  os.writeStruct(1, this.tAward);
  os.writeInt64(2, this.lInvedUid);
  os.writeInt32(3, this.iInvedType);
  os.writeString(4, this.sAvatarUrl);
  os.writeString(5, this.sNickName);
  os.writeInt64(6, this.lInvUid);
  os.writeInt64(7, this.lInvedTime);
  os.writeString(8, this.sOrderId);
};

HUYA.FissionInvitationDetail.prototype.readFrom = function (is) {
  this.iStatus = is.readInt32(0, false, this.iStatus);
  this.tAward = is.readStruct(1, false, this.tAward);
  this.lInvedUid = is.readInt64(2, false, this.lInvedUid);
  this.iInvedType = is.readInt32(3, false, this.iInvedType);
  this.sAvatarUrl = is.readString(4, false, this.sAvatarUrl);
  this.sNickName = is.readString(5, false, this.sNickName);
  this.lInvUid = is.readInt64(6, false, this.lInvUid);
  this.lInvedTime = is.readInt64(7, false, this.lInvedTime);
  this.sOrderId = is.readString(8, false, this.sOrderId);
};

HUYA.FissionInvitationDetailReq = function () {
  this.tId = new HUYA.UserId();
  this.iStart = 0;
  this.iCount = 0;
  this.lPid = 0;
  this.lRoomId = 0;
  this.sChannelId = '';
  this.iChannelType = 0;
  this.iShowType = 0;
};
HUYA.FissionInvitationDetailReq.prototype._clone = function () {
  return new HUYA.FissionInvitationDetailReq();
};
HUYA.FissionInvitationDetailReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionInvitationDetailReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionInvitationDetailReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt32(1, this.iStart);
  os.writeInt32(2, this.iCount);
  os.writeInt64(3, this.lPid);
  os.writeInt64(4, this.lRoomId);
  os.writeString(5, this.sChannelId);
  os.writeInt32(6, this.iChannelType);
  os.writeInt32(7, this.iShowType);
};

HUYA.FissionInvitationDetailReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.iStart = is.readInt32(1, false, this.iStart);
  this.iCount = is.readInt32(2, false, this.iCount);
  this.lPid = is.readInt64(3, false, this.lPid);
  this.lRoomId = is.readInt64(4, false, this.lRoomId);
  this.sChannelId = is.readString(5, false, this.sChannelId);
  this.iChannelType = is.readInt32(6, false, this.iChannelType);
  this.iShowType = is.readInt32(7, false, this.iShowType);
};

HUYA.FissionInvitationDetailRsp = function () {
  this.iReturnCode = 0;
  this.iInvCount = 0;
  this.vDetail = new Taf.Vector(new HUYA.FissionInvitationDetail());
  this.iInvedType = 0;
  this.tTotal = new HUYA.FissionInvitationAward();
  this.iTotal = 0;
  this.mInved = new Taf.Map(new Taf.INT32(), new Taf.INT32());
};
HUYA.FissionInvitationDetailRsp.prototype._clone = function () {
  return new HUYA.FissionInvitationDetailRsp();
};
HUYA.FissionInvitationDetailRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionInvitationDetailRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionInvitationDetailRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iReturnCode);
  os.writeInt32(1, this.iInvCount);
  os.writeVector(2, this.vDetail);
  os.writeInt32(3, this.iInvedType);
  os.writeStruct(4, this.tTotal);
  os.writeInt32(5, this.iTotal);
  os.writeMap(6, this.mInved);
};

HUYA.FissionInvitationDetailRsp.prototype.readFrom = function (is) {
  this.iReturnCode = is.readInt32(0, false, this.iReturnCode);
  this.iInvCount = is.readInt32(1, false, this.iInvCount);
  this.vDetail = is.readVector(2, false, this.vDetail);
  this.iInvedType = is.readInt32(3, false, this.iInvedType);
  this.tTotal = is.readStruct(4, false, this.tTotal);
  this.iTotal = is.readInt32(5, false, this.iTotal);
  this.mInved = is.readMap(6, false, this.mInved);
};

HUYA.AcceptFissionReq = function () {
  this.tId = new HUYA.UserId();
  this.lInvUid = 0;
  this.iType = 0;
  this.sDid = '';
  this.lPid = 0;
  this.lRoomId = 0;
  this.sChannelId = '';
  this.iChannelType = 0;
  this.iSceneType1 = 0;
  this.iSceneType2 = 0;
};
HUYA.AcceptFissionReq.prototype._clone = function () {
  return new HUYA.AcceptFissionReq();
};
HUYA.AcceptFissionReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.AcceptFissionReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.AcceptFissionReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt64(1, this.lInvUid);
  os.writeInt32(2, this.iType);
  os.writeString(3, this.sDid);
  os.writeInt64(4, this.lPid);
  os.writeInt64(5, this.lRoomId);
  os.writeString(6, this.sChannelId);
  os.writeInt32(7, this.iChannelType);
  os.writeInt32(8, this.iSceneType1);
  os.writeInt32(9, this.iSceneType2);
};

HUYA.AcceptFissionReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.lInvUid = is.readInt64(1, false, this.lInvUid);
  this.iType = is.readInt32(2, false, this.iType);
  this.sDid = is.readString(3, false, this.sDid);
  this.lPid = is.readInt64(4, false, this.lPid);
  this.lRoomId = is.readInt64(5, false, this.lRoomId);
  this.sChannelId = is.readString(6, false, this.sChannelId);
  this.iChannelType = is.readInt32(7, false, this.iChannelType);
  this.iSceneType1 = is.readInt32(8, false, this.iSceneType1);
  this.iSceneType2 = is.readInt32(9, false, this.iSceneType2);
};

HUYA.AcceptFissionRsp = function () {
  this.iReturnCode = 0;
  this.lInvedUid = 0;
  this.lInvUid = 0;
  this.tMsg = new HUYA.AcceptMsg();
  this.tAward = new HUYA.FissionInvitationAward();
  this.iInvedType = 0;
  this.sJumpUrl = '';
};
HUYA.AcceptFissionRsp.prototype._clone = function () {
  return new HUYA.AcceptFissionRsp();
};
HUYA.AcceptFissionRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.AcceptFissionRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.AcceptFissionRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iReturnCode);
  os.writeInt64(2, this.lInvedUid);
  os.writeInt64(3, this.lInvUid);
  os.writeStruct(6, this.tMsg);
  os.writeStruct(7, this.tAward);
  os.writeInt32(8, this.iInvedType);
  os.writeString(9, this.sJumpUrl);
};

HUYA.AcceptFissionRsp.prototype.readFrom = function (is) {
  this.iReturnCode = is.readInt32(0, false, this.iReturnCode);
  this.lInvedUid = is.readInt64(2, false, this.lInvedUid);
  this.lInvUid = is.readInt64(3, false, this.lInvUid);
  this.tMsg = is.readStruct(6, false, this.tMsg);
  this.tAward = is.readStruct(7, false, this.tAward);
  this.iInvedType = is.readInt32(8, false, this.iInvedType);
  this.sJumpUrl = is.readString(9, false, this.sJumpUrl);
};

HUYA.FriendFissionRepairEvent = function () {
  this.lInvedUid = 0;
  this.lLoginTime = 0;
};
HUYA.FriendFissionRepairEvent.prototype._clone = function () {
  return new HUYA.FriendFissionRepairEvent();
};
HUYA.FriendFissionRepairEvent.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FriendFissionRepairEvent.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FriendFissionRepairEvent.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lInvedUid);
  os.writeInt64(1, this.lLoginTime);
};

HUYA.FriendFissionRepairEvent.prototype.readFrom = function (is) {
  this.lInvedUid = is.readInt64(0, false, this.lInvedUid);
  this.lLoginTime = is.readInt64(1, false, this.lLoginTime);
};

HUYA.FissionIconByABGroupReq = function () {
  this.tId = new HUYA.UserId();
};
HUYA.FissionIconByABGroupReq.prototype._clone = function () {
  return new HUYA.FissionIconByABGroupReq();
};
HUYA.FissionIconByABGroupReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionIconByABGroupReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionIconByABGroupReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
};

HUYA.FissionIconByABGroupReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
};

HUYA.FissionIconByABGroupRsp = function () {
  this.iV3Group = 0;
  this.sIconUrl = '';
  this.sJumpUrl = '';
};
HUYA.FissionIconByABGroupRsp.prototype._clone = function () {
  return new HUYA.FissionIconByABGroupRsp();
};
HUYA.FissionIconByABGroupRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionIconByABGroupRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionIconByABGroupRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iV3Group);
  os.writeString(1, this.sIconUrl);
  os.writeString(2, this.sJumpUrl);
};

HUYA.FissionIconByABGroupRsp.prototype.readFrom = function (is) {
  this.iV3Group = is.readInt32(0, false, this.iV3Group);
  this.sIconUrl = is.readString(1, false, this.sIconUrl);
  this.sJumpUrl = is.readString(2, false, this.sJumpUrl);
};

HUYA.FissionInvedTypeReq = function () {
  this.tId = new HUYA.UserId();
  this.sMid = '';
};
HUYA.FissionInvedTypeReq.prototype._clone = function () {
  return new HUYA.FissionInvedTypeReq();
};
HUYA.FissionInvedTypeReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionInvedTypeReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionInvedTypeReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeString(1, this.sMid);
};

HUYA.FissionInvedTypeReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.sMid = is.readString(1, false, this.sMid);
};

HUYA.FissionInvedTypeRsp = function () {
  this.iInvedType = 0;
  this.iReturnCode = 0;
};
HUYA.FissionInvedTypeRsp.prototype._clone = function () {
  return new HUYA.FissionInvedTypeRsp();
};
HUYA.FissionInvedTypeRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionInvedTypeRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionInvedTypeRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iInvedType);
  os.writeInt32(1, this.iReturnCode);
};

HUYA.FissionInvedTypeRsp.prototype.readFrom = function (is) {
  this.iInvedType = is.readInt32(0, false, this.iInvedType);
  this.iReturnCode = is.readInt32(1, false, this.iReturnCode);
};

HUYA.FissionInvInfoRsp = function () {
  this.tInvedUserStatus = new HUYA.FissionInvedUserStatus();
  this.vInvedUserStatus = new Taf.Vector(new HUYA.FissionInvedUserStatus());
};
HUYA.FissionInvInfoRsp.prototype._clone = function () {
  return new HUYA.FissionInvInfoRsp();
};
HUYA.FissionInvInfoRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionInvInfoRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionInvInfoRsp.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tInvedUserStatus);
  os.writeVector(1, this.vInvedUserStatus);
};

HUYA.FissionInvInfoRsp.prototype.readFrom = function (is) {
  this.tInvedUserStatus = is.readStruct(0, false, this.tInvedUserStatus);
  this.vInvedUserStatus = is.readVector(1, false, this.vInvedUserStatus);
};

HUYA.FissionOrderInfo = function () {
  this.lUid = 0;
  this.lInvedUid = 0;
  this.sOrderId = '';
};
HUYA.FissionOrderInfo.prototype._clone = function () {
  return new HUYA.FissionOrderInfo();
};
HUYA.FissionOrderInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionOrderInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionOrderInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeInt64(1, this.lInvedUid);
  os.writeString(2, this.sOrderId);
};

HUYA.FissionOrderInfo.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.lInvedUid = is.readInt64(1, false, this.lInvedUid);
  this.sOrderId = is.readString(2, false, this.sOrderId);
};

HUYA.FissionOrderAwardReq = function () {
  this.lUid = 0;
  this.lInvedUid = 0;
  this.iSceneType1 = 0;
  this.iSceneType2 = 0;
  this.sOrderId = '';
};
HUYA.FissionOrderAwardReq.prototype._clone = function () {
  return new HUYA.FissionOrderAwardReq();
};
HUYA.FissionOrderAwardReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionOrderAwardReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionOrderAwardReq.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeInt64(1, this.lInvedUid);
  os.writeInt32(2, this.iSceneType1);
  os.writeInt32(3, this.iSceneType2);
  os.writeString(4, this.sOrderId);
};

HUYA.FissionOrderAwardReq.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.lInvedUid = is.readInt64(1, false, this.lInvedUid);
  this.iSceneType1 = is.readInt32(2, false, this.iSceneType1);
  this.iSceneType2 = is.readInt32(3, false, this.iSceneType2);
  this.sOrderId = is.readString(4, false, this.sOrderId);
};

HUYA.FissionOrderAwardRsp = function () {
  this.iErrCode = 0;
  this.sMsg = '';
  this.tAward = new HUYA.FissionInvitationAward();
};
HUYA.FissionOrderAwardRsp.prototype._clone = function () {
  return new HUYA.FissionOrderAwardRsp();
};
HUYA.FissionOrderAwardRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.FissionOrderAwardRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.FissionOrderAwardRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iErrCode);
  os.writeString(1, this.sMsg);
  os.writeStruct(2, this.tAward);
};

HUYA.FissionOrderAwardRsp.prototype.readFrom = function (is) {
  this.iErrCode = is.readInt32(0, false, this.iErrCode);
  this.sMsg = is.readString(1, false, this.sMsg);
  this.tAward = is.readStruct(2, false, this.tAward);
};
export default HUYA;
